import {
  _INPUT_SALE_DEPOTS,
  _INPUT_SALE_REGROUPING,
  _INPUT_SALE_TURN_OVER,
  _INPUT_SALES_OTHERS,
  _SALE_INPUTS,
  _TAB_INPUT_SALES,
} from "../../../utils/constants";

export const formDataToRow = (
  inputMonths,
  inputPrices,
  volumeValentina,
  volumeTerreRouge,
  site,
  tab,
) => {
  if (inputMonths.length === 0) {
    inputMonths = [
      { fiscalMonth: 1 },
      { fiscalMonth: 2 },
      { fiscalMonth: 3 },
      { fiscalMonth: 4 },
      { fiscalMonth: 5 },
      { fiscalMonth: 6 },
      { fiscalMonth: 7 },
      { fiscalMonth: 8 },
      { fiscalMonth: 9 },
      { fiscalMonth: 10 },
      { fiscalMonth: 11 },
      { fiscalMonth: 12 },
    ];
  }
  const rowMap = new Map();
  const inputPrice = inputPrices.length > 0 ? inputPrices[0] : null;
  volumeValentina =
    volumeValentina?.length > 0 ? getDepotVolumes(volumeValentina) : [];
  volumeTerreRouge =
    volumeTerreRouge?.length > 0 ? getDepotVolumes(volumeTerreRouge) : [];

  const processSales = (sales, type, key) => {
    sales.forEach(({ label, bdVolume, bdPrice }) => {
      const [months, inputsId] = getMonthData(
        inputMonths,
        bdVolume,
        volumeValentina,
        volumeTerreRouge,
        label,
      );

      rowMap.set(rowMap.size + 1, {
        id: null,
        type: type,
        sale: label,
        months: months,
        [key]: label?.includes("Discount")
          ? key === "cash"
            ? "nill"
            : null
          : inputPrice && inputPrice[bdPrice] !== undefined
          ? inputPrice[bdPrice]
          : 0,
        bdVolume: bdVolume,
        bdPrice: bdPrice,
        siteId: site,
        inputsId: inputsId,
        priceId: inputPrice ? inputPrice.id : null,
        calculs: {},
      });
    });
  };

  const getMonthData = (
    inputMonths,
    bdVolume,
    volumeValentina,
    volumeTerreRouge,
    label,
  ) => {
    const months = {};
    const inputsId = {};

    inputMonths.forEach((inputs) => {
      const month = inputs.fiscalMonth;
      let volume =
        label === _INPUT_SALE_DEPOTS.VALENTINA
          ? volumeValentina[month]
          : label === _INPUT_SALE_DEPOTS.TERRE_ROUGE
          ? volumeTerreRouge[month]
          : inputs[bdVolume];

      months[month] = volume;
      inputsId[inputs.fiscalMonth] = inputs.id;
    });

    return [months, inputsId];
  };

  const salesData = [
    [
      _SALES_DISCOUNT_CREDIT,
      _INPUT_SALE_REGROUPING.EXTERNAL_CREDIT_DISCOUNT_GROUPING,
      "credit",
    ],
    [
      _SALES_EXTERNAL_CASH,
      _INPUT_SALE_REGROUPING.EXTERNAL_CASH_GROUPING,
      "cash",
    ],
    [
      _SALES_EXTERNAL_CREDIT,
      _INPUT_SALE_REGROUPING.EXTERNAL_CREDIT_GROUPING,
      "credit",
    ],
    [_SALES_PMX_CREDIT, _INPUT_SALE_REGROUPING.PMX_GROUPING, "credit"],
    [_SALES_DMX_CREDIT, _INPUT_SALE_REGROUPING.DMX_GROUPING, "credit"],
    [_SALES_GCC_CREDIT, _INPUT_SALE_REGROUPING.GCC_GROUPING, "discount"],
    [_SALES_OTHERS_CREDIT, _INPUT_SALE_REGROUPING.OTHER_GROUPING, "discount"],
    [
      _SALES_UNSECURED_CREDIT,
      _INPUT_SALE_REGROUPING.UNSECURED_GROUPING,
      "discount",
    ],
    [_SALES_BLOCK_CREDIT, _INPUT_SALE_REGROUPING.BOLCK_GROUPING, "credit"],
    [_SALES_TOTAL_CREDIT, _INPUT_SALE_REGROUPING.TOTAL_GROUPING, "credit"],
    [_SALES_DEPOTS, _INPUT_SALE_REGROUPING.DEPOT_GROUPING, "credit"],
    tab === "value"
      ? [_SALES_BY_PRODUCT, _INPUT_SALE_REGROUPING.PRODUCT_GROUPING, ""]
      : [[], "", ""],
    tab === "volume"
      ? [_SALES_VOLUMES, _INPUT_SALE_REGROUPING.VOLUMES_GROUPING, ""]
      : [_SALES_TURN_OVER, _INPUT_SALE_REGROUPING.TURN_GROUPING, ""],
    tab === "volume"
      ? [_SALES_BY_PRODUCT, _INPUT_SALE_REGROUPING.PRODUCT_GROUPING, ""]
      : [[], "", ""],
  ];

  salesData.forEach(([sales, type, key]) => {
    processSales(sales, type, key);

    if (
      tab === _TAB_INPUT_SALES.VOLUME &&
      type === _INPUT_SALE_REGROUPING.DEPOT_GROUPING
    ) {
      return;
    }
    if (
      tab === _TAB_INPUT_SALES.VALUE &&
      type === _INPUT_SALE_REGROUPING.TURN_GROUPING
    ) {
      return;
    }

    processSales(_SALES_EMPTY_LINE, `vide ${type.toLowerCase()}`, key);
  });

  return Array.from(rowMap.values());
};

/**
 * Extracts depot volumes from the provided data.
 *
 * @param {Array} data - The input data array containing depot production split values.
 * @returns {Array} An array of values indexed by fiscal month.
 */
const getDepotVolumes = (data) => {
  const values = [];
  data[0].inputSaleDepotProductionSplitValues.forEach((element) => {
    values[element.fiscalMonth] = element.value;
  });

  return values;
};

const _SALES_DISCOUNT_CREDIT = [
  { label: _INPUT_SALES_OTHERS.CREDIT_DISCOUNT, bdPrice: "discountCredit" },
];
const _SALES_EXTERNAL_CASH = [
  {
    label: _SALE_INPUTS.aggregates,
    bdVolume: "externalCashAggregatesVolume",
    bdPrice: "externalCashAggregates",
  },
  {
    label: _SALE_INPUTS.crusherRun,
    bdVolume: "externalCashCrusherVolume",
    bdPrice: "externalCashCrusherRun",
  },
  {
    label: _SALE_INPUTS.rocksand,
    bdVolume: "externalCashRocksandVolume",
    bdPrice: "externalCashRocksand",
  },
  {
    label: _SALE_INPUTS.spallsFilterBoulders,
    bdVolume: "externalCashSpailsVolume",
    bdPrice: "externalCashSpallsFiltersBoulders",
  },
];
const _SALES_EXTERNAL_CREDIT = [
  { label: _SALE_INPUTS.aggregates },
  { label: _SALE_INPUTS.crusherRun },
  { label: _SALE_INPUTS.rocksand },
  { label: _SALE_INPUTS.spallsFilterBoulders },
];
const _SALES_PMX_CREDIT = [
  {
    label: _SALE_INPUTS.aggregates,
    bdVolume: "externalCreditPmxAggregatesVolume",
    bdPrice: "externalCreditPmxAggregates",
  },
  {
    label: _SALE_INPUTS.crusherRun,
    bdVolume: "externalCreditPmxCrusherVolume",
    bdPrice: "externalCreditPmxCrusherRun",
  },
  {
    label: _SALE_INPUTS.rocksand,
    bdVolume: "externalCreditPmxRocksandVolume",
    bdPrice: "externalCreditPmxRocksand",
  },
  {
    label: _SALE_INPUTS.spallsFilterBoulders,
    bdVolume: "externalCreditPmxSpailsVolume",
    bdPrice: "externalCreditPmxSpallsFiltersBoulders",
  },
  {
    label: _INPUT_SALES_OTHERS.DISCOUNT_PMX,
    bdVolume: "externalCreditPmxDiscount",
    bdPrice: "",
  },
];

const _SALES_DMX_CREDIT = [
  {
    label: _SALE_INPUTS.aggregates,
    bdVolume: "externalCreditDmxAggregatesVolume",
    bdPrice: "externalCreditDmxAggregates",
  },
  {
    label: _SALE_INPUTS.crusherRun,
    bdVolume: "externalCreditDmxCrusherVolume",
    bdPrice: "externalCreditDmxCrusherRun",
  },
  {
    label: _SALE_INPUTS.rocksand,
    bdVolume: "externalCreditDmxRocksandVolume",
    bdPrice: "externalCreditDmxRocksand",
  },
  {
    label: _SALE_INPUTS.spallsFilterBoulders,
    bdVolume: "externalCreditDmxSpailsVolume",
    bdPrice: "externalCreditDmxSpallsFiltersBoulders",
  },
  {
    label: _INPUT_SALES_OTHERS.DISCOUNT_DMX,
    bdVolume: "externalCreditDmxDiscount",
    bdPrice: "",
  },
];
const _SALES_GCC_CREDIT = [
  {
    label: _SALE_INPUTS.aggregates,
    bdVolume: "externalCreditGccAggregatesVolume",
    bdPrice: "externalCreditGccAggregatesDiscountAllowed",
  },
  {
    label: _SALE_INPUTS.crusherRun,
    bdVolume: "externalCreditGccCrusherVolume",
    bdPrice: "externalCreditGccCrusherDiscountAllowed",
  },
  {
    label: _SALE_INPUTS.rocksand,
    bdVolume: "externalCreditGccRocksandVolume",
    bdPrice: "externalCreditGccRocksandDiscountAllowed",
  },
  {
    label: _SALE_INPUTS.spallsFilterBoulders,
    bdVolume: "externalCreditGccSpailsVolume",
    bdPrice: "externalCreditGccSpailsDiscountAllowed",
  },
];
const _SALES_OTHERS_CREDIT = [
  {
    label: _SALE_INPUTS.aggregates,
    bdVolume: "externalCreditOtherAggregatesVolume",
    bdPrice: "externalCreditOtherAggregatesDiscountAllowed",
  },
  {
    label: _SALE_INPUTS.crusherRun,
    bdVolume: "externalCreditOtherCrusherVolume",
    bdPrice: "externalCreditOtherCrusherDiscountAllowed",
  },
  {
    label: _SALE_INPUTS.rocksand,
    bdVolume: "externalCreditOtherRocksandVolume",
    bdPrice: "externalCreditOtherRocksandDiscountAllowed",
  },
  {
    label: _SALE_INPUTS.spallsFilterBoulders,
    bdVolume: "externalCreditOtherSpailsVolume",
    bdPrice: "externalCreditOtherSpailsDiscountAllowed",
  },
];
const _SALES_EMPTY_LINE = [{ label: "" }];
const _SALES_UNSECURED_CREDIT = [
  {
    label: _INPUT_SALES_OTHERS.UNSECURED_CREDIT,
    bdVolume: "unsecuredCreditVolume",
    bdPrice: "externalCredUnsecruedDiscountAllowed",
  },
];
const _SALES_BLOCK_CREDIT = [
  {
    label: _INPUT_SALES_OTHERS.INTERNAL_BLOCK,
    bdVolume: "internalBlockVolume",
    bdPrice: "internalCreditBlock",
  },
];

const _SALES_TOTAL_CREDIT = [
  { label: _INPUT_SALES_OTHERS.TOTAL_EXTERNAL_INTERNAL },
];
const _SALES_DEPOTS = [
  { label: _INPUT_SALE_DEPOTS.VALENTINA, bdPrice: "depotCreditValentina" },
  { label: _INPUT_SALE_DEPOTS.TERRE_ROUGE, bdPrice: "depotCreditTerreRouge" },
];
const _SALES_VOLUMES = [
  { label: _INPUT_SALES_OTHERS.EXTERNAL_VOLUME, bdVolume: "externalVolume" },
  { label: _INPUT_SALES_OTHERS.INTERNAL_VOLUME, bdVolume: "internalVolume" },
];
const _SALES_BY_PRODUCT = [
  { label: _INPUT_SALES_OTHERS.BY_PRODUCT_RS, bdVolume: "byProduct" },
];
const _SALES_TURN_OVER = [
  { label: _INPUT_SALE_TURN_OVER.EXTERNAL_TURN_OVER },
  { label: _INPUT_SALE_TURN_OVER.INTERNAL_TURN_OVER },
];
